export default __webpack_public_path__ + "static/media/menu-burger-close.69b56dc3.svg";